import React from "react";
import MesfModal from "../../../../../components/modals/modal.mesf";
import type { TagFromTree } from "../models/TrendingModelsV2";
import { TagsTreeV2 } from "./TagsTreeV2";

interface Props {
	open: boolean;
	handleClose: () => void;
	onTagSelect: (selected: TagFromTree) => void;
}

export const TagsTreeModalV2 = ({ open, handleClose, onTagSelect }: Props) => {
	return (
		<MesfModal
			open={open}
			handleClose={handleClose}
			maxWidth={"lg"}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			title="Tags"
		>
			<MesfModal.Content>
				<TagsTreeV2 onTagSelect={onTagSelect} />
			</MesfModal.Content>
		</MesfModal>
	);
};
